import httpClient from './httpClient';

const END_POINT = '/api/pack_country_domain_functionality';
const getExistAndRestFunctionalities = (module_id, packCountryDomain_id) =>
    httpClient.get(`${END_POINT}/existAndRestFunctionalities/${module_id}/${packCountryDomain_id}`);

const getFunctionalitiesAndModuleByPack = packCountryDomain_id =>
    httpClient.get(`${END_POINT}/getFunctionalitiesAndModuleByPack/${packCountryDomain_id}`);

const addNewFunctionalityForPack = (functionality_id, packCountryDomain_id, value, isDisplayed) =>
    httpClient.post(`${END_POINT}/addNewFunctionalityForPack/${functionality_id}/${packCountryDomain_id}`,
        {value , isDisplayed},
        );

const updateExistFunctionalityForPack = (id, value, isDisplayed) =>
    httpClient.put(END_POINT + '/updateExistFunctionalityForPack/' + id, {value , isDisplayed},);

const deleteExistFunctionalityForPack = (id, idFunctionality, idPackCountryDomain) =>
    httpClient.post(END_POINT + '/deleteExistFunctionalityForPack/' + id, {idFunctionality, idPackCountryDomain});

export {
    getExistAndRestFunctionalities,
    getFunctionalitiesAndModuleByPack,
    addNewFunctionalityForPack,
    updateExistFunctionalityForPack,
    deleteExistFunctionalityForPack
};
